import { render, staticRenderFns } from "./CmsIndexSaveButton.vue?vue&type=template&id=6a43c4fa&scoped=true"
import script from "./CmsIndexSaveButton.vue?vue&type=script&lang=ts"
export * from "./CmsIndexSaveButton.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndexSaveButton.vue?vue&type=style&index=0&id=6a43c4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43c4fa",
  null
  
)

export default component.exports